<adapt-feature-guidance [configItem]="configItem">
    <p>Systems & processes are the way you represent how people and work are organised to carry out an organisation's strategy and achieve
        its aims.</p>
    <p>This includes systems & guidance materials.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem"
                             [team]="team"> </adapt-feature-configuration>
